import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CdkMenuModule} from '@angular/cdk/menu';
import { OverlayModule } from '@angular/cdk/overlay';
import { DialogModule } from '@angular/cdk/dialog';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CdkMenuModule,
    OverlayModule,
    DialogModule
  ],
  exports: [
    CdkMenuModule,
    OverlayModule,
    DialogModule
  ]
})
export class AngularCdkModule { }
